/* eslint-disable no-debugger */
import { Fragment } from 'react';
import Headings from '../../headings/Headings';
import Input from '../../inputs/Input';
import PrimaryButton from '../../buttons/PrimaryButton';
import Dropdown from '../../dropdowns/Dropdown';
import CalendarDateInput from '../../inputs/CalendarDateInput';

const ReportParameters = ({
  title,
  formValues,
  onFormValueChanged,
  onFormDateValueChanged,
  onValueTextPairChanged,
  onRefresh,
  parameters = []
}) => {

  return (
    <Fragment>
      <form noValidate>
        <div className="row">
          <div className="col-xs-12">
            <Headings.H3>{title}</Headings.H3>
          </div>
        </div>
        <div className="row">
          {parameters.map((param) => (
            <div key={param.name} className={param.className || "col-xs-12 col-sm-6 col-md-2"} style={{ width: param.width || 'auto' }}>
              {(param.paramType === 'text' || param.paramType === 'number') ? (
                <Input
                  label={param.label}
                  name={param.name}
                  value={formValues[param.name]}
                  error={param.error || false}
                  message={param.message || `${param.label} is required`}
                  onChange={(value) => { onFormValueChanged(param.name, value) }}
                />
              ) :
                (param.paramType === 'list') ? (
                  <Dropdown
                    label={param.label}
                    name={param.name}
                    value={formValues[param.name]}
                    error={param.error || false}
                    message={param.message || `${param.label} is required`}
                    onChange={(id, value, e) => {
                      e && e.target && e.target.value &&
                        onValueTextPairChanged(e.target.value, param.name, e.target.selectedOptions[0].label, param.label);
                    }}
                    options={param.data}
                    areValuesIntegers={false}
                  />
                ) : 
                  (param.paramType === 'date') ? (
                    <CalendarDateInput
                      label={param.label}
                      name={param.name}
                      value={formValues[param.name]}
                      error={param.error || false}
                      message={param.message || `${param.label} is required`}
                      onChange={(value) => { onFormDateValueChanged(param.name, value) }} />
                  ) : null
                }
            </div>
          ))}

          <div className="col-xs-12 col-sm-6 col-md-2">
            <div style={{ paddingTop: 25, height: 80, alignItems: 'center' }}>
              <PrimaryButton onClick={onRefresh}>Refresh Grid</PrimaryButton>&nbsp;
            </div>
          </div>
        </div>
      </form>
    </Fragment>
  );
};

export default ReportParameters;
